import * as Yup from "yup";

export const CloseStudySchema = Yup.object({
    reason:Yup.string().required("Select atleast one reason")    
});

export const CloseStudySchemaWithReason = Yup.object({
    reason:Yup.string().required("Select atleast one reason"),
    otherReason:Yup.string().required("Other reason is required")
});